import { axios } from "@/lib/axios";
import { IAPIGetSomeStats } from "../../types";

export const getSomeStats = (): Promise<IAPIGetSomeStats> => {
  return axios.get(`/profile-s/bo/api/v1/profiles/stats/global`);
};
